import { useSelector } from 'react-redux'
import { playerTransactionsSelector } from '@/state/player-transactions/slices/index.slices'
import { useTransactionsActions } from './use-transactions-actions.hooks'

import { PlayerTransactionFilters } from '@/state/player-transactions/models'

export const useTransactionsFilters = () => {
  const { getAllTransactions, setTransactionsFilters } =
    useTransactionsActions()

  const { filters, pagination } = useSelector(playerTransactionsSelector)

  // eslint-disable-next-line
  const handleChangeSearch = (newFilter: Partial<PlayerTransactionFilters>) => {
    const newFilters = {
      ...filters,
      ...newFilter,
      page: 1,
    }

    setTransactionsFilters(newFilters)
  }

  const handleChangePage = (newPage: number) => {
    setTransactionsFilters({ ...filters, page: newPage })
    getAllTransactions({ ...filters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < (filters.page || 1)) {
      setTransactionsFilters({ ...filters, limit: newLimit, page: 1 })
      getAllTransactions({ ...filters, limit: newLimit, page: 1 })
    } else {
      setTransactionsFilters({ ...filters, limit: newLimit })
      getAllTransactions({ ...filters, limit: newLimit })
    }
  }

  const submitSearchFilter = (
    overrideFilters?:
      | PlayerTransactionFilters
      | Partial<PlayerTransactionFilters>,
  ) => {
    getAllTransactions({ ...filters, ...overrideFilters })
  }

  return {
    filters,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
    submitSearchFilter,
  }
}
